import { currentYearDateRange, formatAttendanceDays, isValidDateRange, toApiDate } from '@/constants/attendance';

export { currentYearDateRange, isValidDateRange, toApiDate };

export const COMP_TYPE_FILTER_OPTIONS = [
  { label: 'Salary', value: 'salary' },
  { label: 'Hourly', value: 'hourly' },
  { label: 'Per shift', value: 'per_shift' }
];

/** Structured change reasons stored on employee_compensation.change_reason. */
export const COMP_CHANGE_REASON_OPTIONS = [
  { label: 'Annual review', value: 'annual_review' },
  { label: 'Promotion', value: 'promotion' },
  { label: 'Market adjustment', value: 'market_adjustment' },
  { label: 'Correction', value: 'correction' },
  { label: 'Other', value: 'other' }
];

export const COMP_CHANGE_REASON_VALUES = COMP_CHANGE_REASON_OPTIONS.map((row) => row.value);

/** How a salary current_amount is entered. Ignored for hourly / per_shift. */
export const COMP_AMOUNT_BASIS_OPTIONS = [
  { label: 'Monthly', value: 'monthly' },
  { label: 'Semi-monthly', value: 'semi_monthly' },
  { label: 'Annual', value: 'annual' }
];

export const COMP_AMOUNT_BASIS_VALUES = COMP_AMOUNT_BASIS_OPTIONS.map((row) => row.value);

export const COMP_TIME_OFF_FILTER_OPTIONS = [
  { label: 'Has Medical', value: 'sick' },
  { label: 'Has Vacation', value: 'vacation' },
  { label: 'Has Remote', value: 'remote' }
];

export function formatCompensationMoney(value) {
  if (value == null || value === '') return '—';
  const num = Number(value);
  if (Number.isNaN(num)) return '—';
  return num.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
}

export function formatCompensationDays(value) {
  return formatAttendanceDays(value);
}

export {
  COMP_ITEM_CATEGORY_OPTIONS,
  COMP_ITEM_CODES_BY_CATEGORY,
  COMP_ITEM_FREQUENCY_OPTIONS,
  COMP_ITEM_MAX
} from './compensationItems.js';
